module.exports = __webpack_public_path__ + "static/media/pata-light-0.d58e9cbd.svg";